import apiClient from "@/services/api-client";

export const catalogGovernanceService = {
  moduleRevisions: async (moduleId: string) =>
    (await apiClient.get(`/modules/catalog/modules/${moduleId}/revisions`)).data,
  createModuleRevision: async (moduleId: string, payload: Record<string, unknown>) =>
    (await apiClient.post(`/modules/catalog/modules/${moduleId}/revisions`, payload)).data,
  moduleRevisionImpact: async (revisionId: string) =>
    (await apiClient.get(`/modules/catalog/module-revisions/${revisionId}/impact`)).data,
  publishModuleRevision: async (revisionId: string, payload: Record<string, unknown>) =>
    (await apiClient.post(`/modules/catalog/module-revisions/${revisionId}/publish`, payload)).data,
  planRevisions: async (planId: string) =>
    (await apiClient.get(`/modules/catalog/plans/${planId}/revisions`)).data,
  createPlanRevision: async (planId: string, payload: Record<string, unknown>) =>
    (await apiClient.post(`/modules/catalog/plans/${planId}/revisions`, payload)).data,
  planRevisionImpact: async (revisionId: string) =>
    (await apiClient.get(`/modules/catalog/plan-revisions/${revisionId}/impact`)).data,
  publishPlanRevision: async (revisionId: string, payload: Record<string, unknown>) =>
    (await apiClient.post(`/modules/catalog/plan-revisions/${revisionId}/publish`, payload)).data,
  entitlementChanges: async (status?: string) =>
    (await apiClient.get("/modules/entitlement-changes", { params: { status } })).data,
  previewEntitlement: async (payload: Record<string, unknown>) =>
    (await apiClient.post("/modules/entitlement-changes/preview", payload)).data,
  scheduleEntitlement: async (payload: Record<string, unknown>) =>
    (await apiClient.post("/modules/entitlement-changes", payload)).data,
  reviewEntitlement: async (id: string, decision: "APPROVE" | "REJECT", note: string) =>
    (await apiClient.post(`/modules/entitlement-changes/${id}/review`, { decision, note })).data,
};
